/** 옵션 그룹 기본 정보 (API 연동 전 화면용) */
export interface ProductOptionGroupFormData {
  brandCode: string;
  code: string;
  status: string;
  name: string;
  /** 필수 여부 */
  required: boolean;
  /** 다중 선택 */
  multiSelect: boolean;
  /** 최대 선택 옵션 수 */
  maxSelectOptions: number;
  /** 최소 선택 옵션 수 */
  minSelectOptions: number;
  /** 최대 옵션 수량 합 */
  maxOptionQtySum: number;
  /** 최소 옵션 수량 합 */
  minOptionQtySum: number;
}

export interface ProductOptionGroupFormErrors {
  brandCode?: string;
  code?: string;
  status?: string;
  name?: string;
  maxSelectOptions?: string;
  minSelectOptions?: string;
  maxOptionQtySum?: string;
  minOptionQtySum?: string;
}

/** 상품에 매핑된 옵션 그룹 한 줄 (정렬: sortOrder = fractional index) */
export interface ProductMappedOptionGroupLine {
  groupCode: string;
  groupName: string;
  sortOrder: string;
  /** 표시용 (매핑 API·옵션그룹 목록에서 채움) */
  status?: string;
  itemProductCount?: number;
  mappingProductCount?: number;
}

/** 옵션 그룹에 매핑된 상품 한 줄 (정렬: sortOrder = fractional index) */
export interface OptionGroupProductLine {
  productCode: string;
  productName: string;
  /** 기본 선택 여부 */
  defaultSelected: boolean;
  /** 기본 수량 */
  defaultQty: number;
  /** 최대 수량 */
  maxQty: number;
  /** 최소 수량 */
  minQty: number;
  /** 정렬 (fractional index) */
  sortOrder: string;
}

export const DEFAULT_OPTION_GROUP_FORM: ProductOptionGroupFormData = {
  brandCode: '',
  code: '',
  status: 'ACTIVE',
  name: '',
  required: true,
  multiSelect: false,
  maxSelectOptions: 1,
  minSelectOptions: 1,
  maxOptionQtySum: 0,
  minOptionQtySum: 0,
};